/**
 * ChartShell — Card frame for a dashboard chart (title + legend + body).
 * Renders `children` when there is something to plot, otherwise the empty state.
 */
export default function ChartShell({
  title,
  legend = [],
  emptyText = "No data available",
  children,
}) {
  const hasContent = Boolean(children);

  return (
    <div className="dash-chart-card">
      <div className="dash-chart-header">
        <span className="dash-chart-title">{title}</span>
        {legend.length > 0 && (
          <div className="dash-chart-legend">
            {legend.map((item) => (
              <span className="dash-chart-legend-item" key={item.label}>
                <span
                  className="dash-chart-legend-line"
                  style={{ background: item.color }}
                />
                {item.label}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className={`dash-chart-body${hasContent ? " has-content" : ""}`}>
        {hasContent ? children : <div className="dash-chart-empty">{emptyText}</div>}
      </div>
    </div>
  );
}
